import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Link } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();

  const login = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      nav("/dashboard"); // ✅ Giriş başarılıysa dashboard
    } catch (e) {
      alert("Giriş hatası: " + e.message);
    }
  };

  return (
    <div style={{ padding: 20, maxWidth: 400, margin: "60px auto" }}>
      <h2>Giriş</h2>

      <input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: "100%", padding: 8, marginBottom: 10 }}
      />

      <input
        type="password"
        placeholder="Parola"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: "100%", padding: 8, marginBottom: 10 }}
      />

      <button
        onClick={login}
        style={{ width: "100%", padding: 10 }}
      >
        Giriş Yap
      </button>

      {/* ✅ REGISTER GEÇİŞİ BURADA */}
      <p style={{ marginTop: 15, textAlign: "center" }}>
        Hesabın yok mu? <Link to="/register">Kayıt Ol</Link>
      </p>
    </div>
  );
}
